import { Link } from 'react-router-dom'
import './Brand.css'

function Brand({ to = '/' }) {
  return (
    <Link className="brand" to={to} aria-label="Codetalk home">
      <span className="brand-name">Codetalk</span>
    </Link>
  )
}

export default Brand
